import { render, staticRenderFns } from "./officialSub.vue?vue&type=template&id=cb4b75ac&scoped=true"
import script from "./officialSub.vue?vue&type=script&lang=js"
export * from "./officialSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b75ac",
  null
  
)

export default component.exports